module.exports = __webpack_public_path__ + "img/green.b42d6776.svg";